// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { ISharedNewsDetail } from 'interfaces/shared'
import {
  INewsWebpageApiGetResponse,
  INewsWebpageApiGetAllResponse,
  INewsWebpageApiPaginatedResponse,
} from 'interfaces/webpage/news/news-api.interface'
import { INewsWebpageGetAttrs, INewsWebpageGetAllAttrs } from 'interfaces/webpage/news/news-view.interface'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'
import {
  withHelper_baseNews,
  withHelper_baseNewsDetail,
  withHelper_baseResponsePaginationTypes,
} from 'models/extensions/with-helper'

const NewsWebpageStore = types
  .model('ContactUsWebpage')
  .props({
    newsWebpage_isLoading: types.optional(types.boolean, false),
    newsWebpage_news: types.optional(
      types.model('NewsPaginated').props(withHelper_baseResponsePaginationTypes(withHelper_baseNews())),
      {},
    ),
    newsWebpage_detail: types.optional(withHelper_baseNewsDetail(), {}),
  })
  .actions(self => ({
    newsWebpage_SET_LOADING: (payload: boolean): void => {
      self.newsWebpage_isLoading = payload
    },
    newsWebpage_SET_NEWS: (payload: INewsWebpageApiPaginatedResponse): void => {
      self.newsWebpage_news = cast(payload)
    },
    newsWebpage_SET_DETAIL: (payload: ISharedNewsDetail): void => {
      self.newsWebpage_detail = cast(payload)
    },
    newsWebpage_CLEAR_NEWS: (): void => {
      self.newsWebpage_news = cast({})
    },
    newsWebpage_CLEAR_DETAIL: (): void => {
      self.newsWebpage_detail = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch all news
     *
     * @param {INewsWebpageGetAllAttrs} payload
     *
     * @return {any} any
     */
    newsWebpage_fetch: flow(function* (payload: INewsWebpageGetAllAttrs) {
      self.newsWebpage_SET_LOADING(true)

      const response: INewsWebpageApiGetAllResponse = yield self.environment.newsWebpageApi.news_getAll({
        body: { ...payload.body },
        requestConfig: { ...payload.requestConfig },
      })

      if (response.ok) {
        self.newsWebpage_SET_NEWS(response.res.data)

        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response failed
        if (payload?.onError) payload.onError()
      }

      self.newsWebpage_SET_LOADING(false)
    }),

    /**
     * @description Fetch news detail
     *
     * @param {INewsWebpageGetAttrs} payload
     *
     * @return {any} any
     */
    newsWebpage_fetchDetail: flow(function* (payload: INewsWebpageGetAttrs) {
      self.newsWebpage_SET_LOADING(true)

      const response: INewsWebpageApiGetResponse = yield self.environment.newsWebpageApi.news_get({
        params: { ...payload.params },
        requestConfig: { ...payload.requestConfig },
      })

      if (response.ok) {
        self.newsWebpage_SET_DETAIL(response.res.data)

        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response failed
        if (payload?.onError) payload.onError()
      }

      self.newsWebpage_SET_LOADING(false)
    }),
  }))

export const createNewsWebpageStoreDefaultModel = () => types.optional(NewsWebpageStore, {})
